import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { NavLink } from "react-router-dom";

class ChatRooms extends Component {
  constructor(props) {
    super(props);
    this.state.myLists = props.chatroomJson;
  }
  state = {
    myLists: [],
    chatroomMessages: [],
    chatroomMembers: [],
    chatroomView: true,
    chatroomMessagesView: false,
    chatroomID: "",
    chatroomTitle: "",
    chatroomImage: "",
    chatroomLastMessage: "",
    chatroomMembersCount: "",
    isPaused: false,
    isModal: false,
  };
  componentDidMount() {
    this.viewMessageRoom(1);
  }
  scrollToBottom = () => {
    var objDiv = document.getElementById("chatroomBox");
    objDiv.scrollTop = objDiv.scrollHeight;
    //const e = document.getElementsByClassName("fixed-bottom")[0];
    //e.scrollIntoView({behavior: "smooth"});
  };
  toggleModal = () => {
    this.setState({ isModal: !this.state.isModal });
  };
  toggleChatRoom = () => {
    this.setState({ chatroomView: !this.state.chatroomView });
    this.setState({ chatroomMessagesView: !this.state.chatroomMessagesView });
  };
  viewMessageRoom = (roomID) => {
    this.setState({ isPaused: true });
    this.setState({ chatroomView: false });
    const token = localStorage.getItem("token");
    if (token !== null) {
      if (roomID !== null) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("roomID", roomID);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/get-chatroom-messages`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.setState({ chatroomID: roomID });
                this.setState({ chatroomTitle: myObject.room_title });
                this.setState({ chatroomImage: myObject.room_image });
                this.setState({
                  chatroomLastMessage: myObject.room_lastmessage,
                });
                this.setState({ chatroomMessages: myObject.data }, function() {
                  this.setState({ isPaused: false });
                  this.setState({ chatroomMessagesView: true }, function() {
                    this.props.getChatMessageUnseen();
                    this.scrollToBottom();
                  });
                });
              } else {
                this.setState({ isPaused: false });
                this.setState({ chatroomView: true });
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    }
  };
  viewChatRoomMembers = (roomID) => {
    this.setState({ isPaused: true });
    const token = localStorage.getItem("token");
    if (token !== null) {
      if (roomID !== null) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("roomID", roomID);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/get-chatroom-members`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.setState({ chatroomMembersCount: myObject.count_member });
                this.setState({ chatroomMembers: myObject.data }, function() {
                  this.setState({ isPaused: false });
                  this.toggleModal();
                });
              } else {
                this.setState({ isPaused: false });
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    }
  };
  render() {
    const listItems_Active = this.state.myLists
      .filter((e) => e.user_permission === true)
      .map((myList) => (
        <div
          key={myList.id}
          className={
            this.state.myLists.filter((e) => e.user_permission === true)
              .length > 1
              ? "col-6 mt-2"
              : "col-12 mt-2"
          }
          onClick={() => this.viewMessageRoom(myList.id)}
        >
          <div className="w-100 active dina-bc-blue rounded text-center p-1">
            <div className="img">
              <img
                src={myList.room_image}
                alt={myList.room_title}
                className="img-circle avatar"
              />
            </div>
            <div className="title wp-text text-white mt-1">
              <b>نام اتاق: </b>
              <b>{myList.room_title}</b>
            </div>
            <div className="describe wp-text-small text-white">
              <b>تعداد اعضا:</b> {myList.room_members}
            </div>
          </div>
        </div>
      ));
    // const listItems = this.state.myLists.filter(e => e.user_permission !== true).map((myList) =>
    // <div key={myList.id} className="col-4 text-center my-1 d-flex">
    //   <div className="w-100 bg-light-chat p-1 rounded hv-60">
    //     <div className='title wp-text-small dina-fc-blue'>
    //       <b>{myList.room_title}</b>
    //     </div>
    //     <div className='describe wp-text-small'>
    //       <b>{myList.room_members} عضو</b>
    //     </div>
    //   </div>
    // </div>
    // );
    const listMessage = this.state.chatroomMessages.map((myList) => (
      <div key={myList.id} className="col-12 mt-2 p-2">
        <div className="bg-light w-100 p-2">
          <div className="header wp-text-small text-left dina-fc-blue">
            {myList.sender}
          </div>
          <div className="body-text title">
            {myList.message_text !== null ? (
              <p className="wp-text text-justify">{myList.message_text}</p>
            ) : null}
            {myList.message_link !== null ? (
              <a href={myList.message_link} title="دیناپارت">
                {myList.message_link}
              </a>
            ) : null}
            {myList.message_media !== null ? (
              <div class="chat-image">
                <img src={myList.message_media} alt="دیناپارت" />
              </div>
            ) : null}
          </div>
          <div className="describe wp-text-small text-left">
            {myList.message_send_date}
          </div>
        </div>
      </div>
    ));
    const listMembers = this.state.chatroomMembers.map((myList) => (
      <div key={myList.id} className="col-12 text-center my-1 d-flex">
        <div className="w-100 bg-light p-1 rounded">
          <div className="img">
            <img
              src={myList.user_image}
              alt={myList.user_name}
              className="img-circle avatar"
            />
          </div>
          <div className="title wp-text-small dina-fc-blue">
            <b>{myList.user_name}</b>
          </div>
          <div className="describe wp-text-small dina-fc-blue">
            <b>تاریخ عضویت: {myList.user_join}</b>
          </div>
        </div>
      </div>
    ));
    if (this.state.isPaused) {
      return (
        <div className="container-fluid body bg-light">
          <div className="row vh-100">
            <div className="cssload-thecube m-auto">
              <div className="cssload-cube cssload-c1"></div>
              <div className="cssload-cube cssload-c2"></div>
              <div className="cssload-cube cssload-c4"></div>
              <div className="cssload-cube cssload-c3"></div>
            </div>
          </div>
        </div>
      );
    }
    if (this.state.chatroomView) {
      return (
        <div className="container-fluid body-padding-bottom">
          <div className="row">
            <p className="wp-header-chat active">تالارهای گفتگو شما</p>
            <div className="col-12 chat">
              <div className="row">
                {listItems_Active.length === 0 ? (
                  <div className="col-12 mt-2 Array-item">
                    <div className="title">
                      هیچ تالاری برای مشاهده وجود ندارد.
                    </div>
                  </div>
                ) : (
                  listItems_Active
                )}
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-sm alert-info text-left mb-0 d-inline-flex">
                <p className="wp-text text-dark text-center mb-0">
                  با تعیین استان محل فعالیت خود، در شبکه تعمیرکاران استان خود
                  عضویت داشته باشید.
                </p>
                <button className="btn dina-btn-blue btn-sm rounded-pill text-nowrap">
                  <NavLink
                    to="/profile"
                    className="text-decoration-none text-white"
                  >
                    تکمیل پروفایل
                  </NavLink>
                </button>
              </div>
            </div>
            {/* <p className='wp-header-chat'>تالارهای گفتگوی سایر استان ها</p>
            {
              (listItems.length === 0) ? <div className='col-12 Array-item'><div className='title'>هیچ تالاری برای مشاهده وجود ندارد.</div></div> : listItems
            } */}
          </div>
        </div>
      );
    }
    if (this.state.chatroomMessagesView) {
      return (
        <div className="container-fluid body-padding-bottom">
          <div className="row">
            <Modal show={this.state.isModal} onHide={this.toggleModal}>
              <Modal.Header closeButton>
                <Modal.Title>
                  تعداد اعضای اتاق {this.state.chatroomMembersCount} عضو
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ul className="Array active">
                  {listMembers.length === 0 ? (
                    <li className="Array-item">
                      <div className="title">
                        هیچ شخصی در این تالار برای مشاهده وجود ندارد.
                      </div>
                    </li>
                  ) : (
                    listMembers
                  )}
                </ul>
              </Modal.Body>
            </Modal>
            <div className="wp-header-chat active chat-room-header">
              {/* <button className="btn btn-dark rounded-pill float-left" onClick={this.toggleChatRoom}>بازگشت</button> */}
              <NavLink
                to="/home"
                className="btn btn-dark rounded-pill float-left"
              >
                بازگشت
              </NavLink>
              <div className="img">
                <img
                  src={this.state.chatroomImage}
                  alt={this.state.chatroomTitle}
                  className="img-circle avatar"
                />
              </div>
              <div className="title">
                <b>{this.state.chatroomTitle}</b>
              </div>
              <div className="describe wp-text-small">
                <b>آخرین فعالیت: {this.state.chatroomLastMessage}</b>
              </div>
              <div
                className="member btn dina-btn-blue mt-2"
                onClick={() => this.viewChatRoomMembers(this.state.chatroomID)}
              >
                مشاهده اعضا
              </div>
            </div>
            <ul className="Array chat active" id="chatroomBox">
              {listMessage.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هیچ پیامی در این تالار برای مشاهده وجود ندارد.
                  </div>
                </li>
              ) : (
                listMessage
              )}
            </ul>
          </div>
        </div>
      );
    }
  }
}

export default ChatRooms;
